{
  "contractVersion": 1,
  "generatedAt": "2027-01-02T00:00:00.000Z",
  "season": { "id": "season-2027-q1", "name": "Season 5", "dayNumber": 2 },
  "sides": {
    "beornings": { "totalPoints": 51200, "sharePct": 91.4 },
    "lothwen": { "totalPoints": 4820, "sharePct": 8.6 }
  },
  "world": { "treesChoppedTotal": 512, "treesPlantedTotal": 48 },
  "events": [
    { "id": 610, "type": "tree_felled", "side": "beornings", "at": "2026-12-30" },
    { "id": 611, "type": "season_reset", "seasonId": "season-2027-q1", "at": "2027-01-01" },
    { "id": 612, "type": "tree_planted", "side": "lothwen", "at": "2027-01-02" }
  ]
}
